import React, { FC } from 'react';
import styles from './PageLoading.module.scss';
import { twMerge } from '@shared/utils/twMerge';

type PageLoadingProps = {
  className?: string;
  children?: React.ReactNode;
  percent?: number;
  loaded?: number;
  total?: number;
  label?: string;
};

export const PageLoading: FC<PageLoadingProps> = ({
  className,
  percent,
  loaded,
  total,
  label = 'items',
}) => {
  const hasProgress = typeof percent === 'number';
  const clampedPercent = hasProgress
    ? Math.min(100, Math.max(0, Math.round(percent as number)))
    : 0;
  const hasCount = typeof loaded === 'number' && typeof total === 'number';
  const showSection = hasProgress || hasCount;

  return (
    <div
      data-testid='PageLoading'
      className={twMerge(
        'relative flex flex-col items-center justify-center gap-6',
        className
      )}
    >
      <div className='relative h-[130px] w-[130px]'>
        <div className={styles.ring}></div>
        <div className={styles.ring}></div>
        <div className={styles.ring}></div>
        <div className={styles.ring}></div>
      </div>

      {showSection && (
        <div className='flex flex-col items-center gap-2'>
          {hasProgress && (
            <div className='h-1.5 w-48 overflow-hidden rounded-full bg-vividTangelo/20'>
              <div
                className='h-full rounded-full bg-vividTangelo transition-[width] duration-200 ease-out'
                style={{ width: `${clampedPercent}%` }}
              />
            </div>
          )}
          <div className='text-center text-sm font-medium text-vividTangelo'>
            {hasCount ? (
              <>
                Loaded {loaded} of {total} {label}
              </>
            ) : (
              <>Loaded {clampedPercent}%</>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
